import Vue from 'vue';
import { mapGetters } from 'vuex';
export default Vue.extend({
    name: 'DarkLayout',
    computed: Object.assign(Object.assign({}, mapGetters('user', ['getUserData'])), { isScreenerPage() {
            return this.$route.name === 'screener' || this.$route.name === 'terminal';
        } })
});
